import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import i18nLv from './assets/i18n/lv.json';
import i18nEn from './assets/i18n/en.json';
import { setLocale } from 'yup';
import { registerLocale } from 'react-datepicker';
import lv from 'date-fns/locale/lv';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: { translation: i18nEn },
      lv: { translation: i18nLv },
    },
    lng: 'lv',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    nsSeparator: false,
    debug: false,
  });

registerLocale('lv-LV', lv);

setLocale({
  mixed: {
    default: 'Invalid field (Add error message in i18n.ts!!!)',
    required: 'Field is required',
    notType: (props: any) => `Field must be a valid ${props.type}`,
    email: 'Field must be a valid email',
  },
  string: {
    length: (props: any) =>
      i18n.t('Field must be exactly {{length}} characters', {
        length: props.length,
      }),
    max: (props: any) =>
      i18n.t('Field must be at most {{max}} characters', {
        max: props.max,
      }),
    email: 'Field must be a valid email',
    uuid: 'Field must be a valid value',
  },
  number: {
    min: (props: any) =>
      i18n.t('Field must be greater than or equal to {{min}}', {
        min: props.min,
      }),
    max: 'Field must be less than or equal to {{max}}',
    lessThan: 'Field must be less than {{less}}',
    moreThan: 'Field must be greater than {{more}}',
    positive: 'Field must be a positive number',
    negative: 'Field must be a negative number',
    integer: 'Field must be an integer',
  },
  array: {
    min: (props: any) =>
      i18n.t('Field must have at least {{min}} items', {
        min: props.min,
      }),
    max: (props: any) =>
      i18n.t('Field must have less than or equal to {{max}} items', {
        max: props.max,
      }),
    length: 'Field must be have {{length}} items',
  },
});
